import { Card, CardHeader, Typography, Button } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { TbTransfer } from "react-icons/tb";
import { setDialog } from "../../../../../app/slices/transferOrderSlice";
import TransferOrderForm from "../../form";
import TransferOrderDetails from "../details";
import Permission from "../../../../../components/userPermission/userPermission";

const TransferOrderHeader = () => {
  const dispatch = useDispatch();
  const _TransferOrder = useSelector((state) => state.transferOrder);

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            مناقلة المواد
          </Typography>
        }
        avatar={<TbTransfer size={20} />}
        action={
          <Permission permission="invoice_manager">
            <Button
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<IoIosAddCircleOutline />}
              onClick={() => dispatch(setDialog())}
            >
              اضافة مناقلة
            </Button>
          </Permission>
        }
      />
      {_TransferOrder.transferOrder.dialog ? <TransferOrderForm /> : null}
      {_TransferOrder.details.dialog ? <TransferOrderDetails /> : null}
    </Card>
  );
};

export default TransferOrderHeader;
